import React from 'react';
import HeaderNoStepper, { IHeaderNoStepperProps } from '../HeaderNoStepper';
import { ContentContainer } from '@snsw-gel/react';

interface ILayoutProps extends IHeaderNoStepperProps {
    children: React.ReactNode;
}

const DefaultNoStepperLayout: React.FC<ILayoutProps> = ({ children, ...props }: ILayoutProps) => {
    return (
        <div>
            <HeaderNoStepper {...props} />
            <ContentContainer>{children}</ContentContainer>
        </div>
    );
};

export default DefaultNoStepperLayout;
